import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createDisplay, updateDisplay } from '../api';
import { handleFormSubmit } from './helpers/handle-api-form-call';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processSaveDisplay(action: any) {
  const { data, formikActions } = action;
  const { id, serviceProviderId } = data;
  yield handleFormSubmit({
    id,
    formikActions,
    updateFn: async () => updateDisplay(id, { serviceProviderId, ...data }),
    createFn: async () => createDisplay({ serviceProviderId, ...data })
  });
}

export default function* saveDisplaySaga() {
  yield takeLatest(AT.SAVE_DISPLAY_SAGA, processSaveDisplay);
}
